<form #ingredientForm="ngForm" class="editable-ingredients-container" *ngIf="showForm" [@fadeInAnimation]>
  <div nz-row nzGutter="16">
    <div class="mb-xxs" nz-col [nzXs]="24" [nzLg]="24" *ngIf="hasCategoryFilter">
      <div class="text-info mb-xs">Filtro por categoría de alimentos</div>
      <div nz-row [nzGutter]="[0, 7]" class="categories-row">
        <div nz-col class="mr-xs" *ngIf="selectedIngredientCategories?.length === 0">
          <button
            [disabled]="this.disabled"
            nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Seleccionar categoría'" nzPopoverMouseEnterDelay="0.3" nzPopoverPlacement="topLeft"
            (click)="onToggleCategoryIngredientEditMode(true)"
            nz-button
            class="add-category-btn"
            @fadeInAnimation>
            <i nz-icon nzType="plus" nzTheme="outline" style="font-size: 11px;"></i>
          </button>
        </div>
        <div nz-col *ngFor="let category of selectedIngredientCategories; index as i">
          <nz-tag class="tag cursor-pointer" [class.disable-tags]="categoryIngredientMode" nz-popover="" nzPopoverTitle=""
                  [nzPopoverContent]="!categoryIngredientMode ? 'Remover categoría' : ''" [style.background-color]="category.color"
                  (click)="onRemoveIngredientCategory(category?._id)">
            {{ category.name }}
          </nz-tag>
        </div>
      </div>

      <nz-select
        class="mb-sm mt-xs"
        #ngTags="ngModel"
        #categoryIngredientSelectInput
        *ngIf="categoryIngredientMode && ingredientCategories.length> 0"
        nzShowSearch
        [(ngModel)]="selectedIngredientCategoriesIds"
        name="tags"
        nzMode="multiple"
        nzPlaceHolder="Cualquier categoría"
        @fadeInAnimation
        (ngModelChange)="onSelectIngredientCategories($event)"
        (nzOpenChange)="onOpenChangeCategoriesSelect($event)"> <!-- (ngModelChange)="onSelectTags($event)" -->
        <nz-option *ngFor="let category of ingredientCategories" [nzValue]="category?._id" [nzLabel]="category.name"></nz-option>
      </nz-select>
    </div>

    <div class="mt-xs" nz-col [nzXs]="24" *ngIf="hasIngredientName">
<!--      <div class="text-info mb-xs">Ingrediente</div>-->
      <nz-select
        #ingredientSelectInput
        [required]="true"
        [nzDisabled]="categoryIngredientMode || disabled"
        nzShowSearch
        name="ingredientId"
        #ingredientId="ngModel"
        class="select-search-ingredient"
        nzPlaceHolder="Selecciona el ingrediente"
        [(ngModel)]="selectedIngredient._id"
        [nzOptionHeightPx]="!isLoadingFirstIngredients ? 115 : 80"
        [nzServerSearch]="true"
        [nzOptionOverflowSize]="6"
        [nzDropdownRender]="renderTemplate"
        (ngModelChange)="onChooseIngredient($event)"
        (nzOnSearch)="onSearchIngredient($event)">
        <ng-container *ngIf="!isLoadingFirstIngredients; else loadingFirstIngredients">
          <nz-option nzCustomContent *ngFor="let ingredient of (ingredients$ | async)" [nzValue]="ingredient?._id" [nzLabel]="ingredient?.name" [nzHide]="excludedIngredients.includes(ingredient._id)">
            <div nz-row nzGutter="16" class="custom-option-row-ingredient">
              <div nz-col [nzXs]="24" class="ingredient-name truncate">
                <p>{{ ingredient.name }}</p>
                <p class="tw-text-3xs tw-text-gray-600">SMAE</p>
              </div>
              <div nz-col [nzXs]="24" class="macronutrients macros-in-select d-flex justify-content-between mb-xxs justify-content-between">
                <div class="macronutrient">
                  <p class="text-info-bold-xs">Calorías</p>
                  <p class="text-info text-bold text-small">{{ ingredient.energy_kcal !== -1 ? ingredient.energy_kcal?.toFixed(2) : 0 }} kcal</p>
                </div>
                <div class="macronutrient">
                  <p class="text-info-bold-xs">Grasas</p>
                  <p class="text-info text-bold text-small">{{ ingredient.totalFat_g !== -1 ? ingredient.totalFat_g?.toFixed(2) : 0 }} g</p>
                </div>
                <div class="macronutrient">
                  <p class="text-info-bold-xs">H.C</p>
                  <p class="text-info text-bold text-small">{{ ingredient.carbohydrate_g !== -1 ? ingredient.carbohydrate_g?.toFixed(2) : 0 }} g</p>
                </div>
                <div class="macronutrient">
                  <p class="text-info-bold-xs">Proteínas</p>
                  <p class="text-info text-bold text-small">{{ ingredient.protein_g !== -1 ? ingredient.protein_g?.toFixed(2) : 0 }} g</p>
                </div>
                <div class="macronutrient">
                  <p class="text-info-bold-xs">Fibra</p>
                  <p class="text-info text-bold text-small">{{ ingredient.dietaryFiber_g !== -1 ? ingredient.dietaryFiber_g?.toFixed(2) : 0 }} g</p>
                </div>
              </div>
              <nz-divider style="margin: 10px 0 0 0;"></nz-divider>
            </div>
          </nz-option>
        </ng-container>
        <ng-template #loadingFirstIngredients>
          <nz-option nzCustomContent [nzDisabled]="true">
            <div class="tw-h-4">
              <nz-spin class="mt-xlg mb-xlg"></nz-spin>
            </div>
          </nz-option>
        </ng-template>
      </nz-select>
      <ng-template #renderTemplate>
        <nz-spin class="tw-h-0.5 mt-sm mb-sm" *ngIf="isLoadingIngredients"></nz-spin>
      </ng-template>
      <app-message-field [field]="ingredientId"></app-message-field>
    </div>
  </div>
</form>
